import L from 'leaflet';
import MAP_CONSTANTS from 'constants/map';

// Icon Repository: https://github.com/pointhi/leaflet-color-markers
const ICON_BASE_URL =
  'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img';
const SHADOW_URL =
  'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png';

export const blackIcon = new L.Icon({
  iconUrl: `${ICON_BASE_URL}/marker-icon-black.png`,
  shadowUrl: SHADOW_URL,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const blueIcon = new L.Icon({
  iconUrl: `${ICON_BASE_URL}/marker-icon-blue.png`,
  shadowUrl: SHADOW_URL,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const goldIcon = new L.Icon({
  iconUrl: `${ICON_BASE_URL}/marker-icon-gold.png`,
  shadowUrl: SHADOW_URL,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const greenIcon = new L.Icon({
  iconUrl: `${ICON_BASE_URL}/marker-icon-green.png`,
  shadowUrl: SHADOW_URL,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const greyIcon = new L.Icon({
  iconUrl: `${ICON_BASE_URL}/marker-icon-grey.png`,
  shadowUrl: SHADOW_URL,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const orangeIcon = new L.Icon({
  iconUrl: `${ICON_BASE_URL}marker-icon-orange.png`,
  shadowUrl: SHADOW_URL,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const redIcon = new L.Icon({
  iconUrl: `${ICON_BASE_URL}/marker-icon-red.png`,
  shadowUrl: SHADOW_URL,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const violetIcon = new L.Icon({
  iconUrl: `${ICON_BASE_URL}/marker-icon-violet.png`,
  shadowUrl: SHADOW_URL,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const yellowIcon = new L.Icon({
  iconUrl: `${ICON_BASE_URL}/marker-icon-yellow.png`,
  shadowUrl: SHADOW_URL,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const blackBus = new L.Icon({
  iconUrl: MAP_CONSTANTS.MARKERS_URLS.BLACK_BUS,
  shadowUrl: SHADOW_URL,
  iconSize: [26, 35],
  iconAnchor: [13, 35],
  shadowSize: [35, 35],
  popupAnchor: [1, -34],
});

export const yellowBus = new L.Icon({
  iconUrl: MAP_CONSTANTS.MARKERS_URLS.YELLOW_BUS,
  shadowUrl: SHADOW_URL,
  iconSize: [26, 35],
  iconAnchor: [13, 35],
  shadowSize: [35, 35],
  popupAnchor: [1, -34],
});

export const purchase = new L.Icon({
  iconUrl: MAP_CONSTANTS.MARKERS_URLS.PURCHASE,
  shadowUrl: SHADOW_URL,
  iconSize: [26, 35],
  iconAnchor: [13, 35],
  shadowSize: [35, 35],
  popupAnchor: [1, -34],
});

export const boarding = new L.Icon({
  iconUrl: MAP_CONSTANTS.MARKERS_URLS.BOARDING,
  shadowUrl: SHADOW_URL,
  iconSize: [26, 35],
  iconAnchor: [13, 35],
  shadowSize: [35, 35],
  popupAnchor: [1, -34],
});

export const landing = new L.Icon({
  iconUrl: MAP_CONSTANTS.MARKERS_URLS.LANDING,
  shadowUrl: SHADOW_URL,
  iconSize: [26, 35],
  iconAnchor: [13, 35],
  shadowSize: [35, 35],
  popupAnchor: [1, -34],
});
